import React from 'react';
import Layout from '@ui-components/layout';
import { PAYMENT_STATUS } from '@constants';
import './main.scss';

export default ({ status }) => {
  return (
    <Layout title="Formulario de pago" subtitle="">
      <div className="payments-status">
        <p>Transacción finalizada.</p>

        {status === PAYMENT_STATUS.PAID && (
          <p>El pago se completó con éxito.</p>
        )}

        {status === PAYMENT_STATUS.PENDING && (
          <p>El pago se está procesando.</p>
        )}

        {status === PAYMENT_STATUS.REJECTED && <p>El pago fue rechazada.</p>}
      </div>
    </Layout>
  );
};
